import Grid from '@material-ui/core/Grid';
// import { FacebookShareButton, FacebookIcon, EmailIcon } from 'react-share'
// import ShareButton from 'react-share/lib/ShareButton';
import { FacebookShare } from 'react-share-kit';
import { MetaHeadEmbed, getShareUrl, getFacebookUrl } from '@phntms/react-share';
import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { baseTheme } from '../../../theme';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    shareButton: {
      backgroundColor: '#747474',
      border: 'none',
      padding: '0px',
      font: 'inherit',
      color: 'inherit',
      cursor: 'pointer',
      height: '64px',
      width: '64px',
    },
  }),
);
export default function ShareModal(props: any) {
  const { post, isOpen, closeShareModal } = props;
  const classes = useStyles(baseTheme);
  const siteUrl = 'https://reliht.com';
  const generateShareLink = () => {
    if (!(post && post.id)) {
      return siteUrl;
    }
    return `${siteUrl}/shared/${post.id}`;
  };
  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(generateShareLink());
    closeShareModal();
  };
  return (
        isOpen &&
            <React.Fragment>
                <Typography>
                    Link to share:
                </Typography>
                <Typography onClick={copyLinkToClipboard}>
                    {generateShareLink()}
                </Typography>
                <Grid>
                    <FacebookShare
                      url={generateShareLink()}
                      title={post.title}
                      quote={post.title}
                      // onShareWindowClose={closeShareModal}
                    />
                </Grid>
            </React.Fragment>
  );
}
